import { Component, OnInit, ChangeDetectorRef, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { AlertService, Constants } from 'src/app/shared';
import { SiteService, LoadService, CommonService, UserManagementService } from 'src/app/services/index';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { SiteModel } from 'src/app/models/index';
import { AddUserSuccessModalComponent } from '../../add/add-user/add-user-success-modal/add-user-success-modal.component';
import { SsoLoginModalComponent } from '../sso-login-modal/sso-login-modal.component';
import { FeatureSelectionModalComponent } from '../feature-selection-modal/feature-selection-modal.component';


@Component({
  selector: 'app-add-edit-user-modal',
  templateUrl: './add-edit-user-modal.component.html',
  styleUrls: ['./add-edit-user-modal.component.scss']
})
export class AddEditUserModalComponent implements OnInit {
  formData: FormGroup;
  sites: any;
  roles: any;
  selected: SiteModel;
  user = {
    emailRecipientClass: 'To',
    email: '',
    userRId: '',
    ntId: '',
    role: {},
    sites: [],
    activities: [],
    useSSO: false
  };

  error = {
    role: '',
    validation: undefined,
    message: ''
  };
  errMsg = '';
  maxSiteUserPerSite = 0;
  emailRecipientClass = ['To', 'Cc', 'Bcc', 'None'];
  firstNamePattern = '^([^0-9]*)$';
  typed = false;
  validation = undefined;
  MULTIPLE_SITE = false;
  SINGLE_SITE = false;
  ID_label = this.user.useSSO ? 'SSO ID' : 'Application ID';
  isSelected = false;
  tittle = '';
  countSelected = 0;
  selectedFeatures: any;
  allowShowAddFeatureButton = false;
  isEditMode = false;
  selectedSiteIds = [];
  add_eidt_label = 'Add User'
  constructor(private dialogRef: MatDialogRef<AddEditUserModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,

    private dialog: MatDialog,
    private alertService: AlertService, private siteService: SiteService,
    private commonService: CommonService,
    private userManagementService: UserManagementService,
    private cdRef: ChangeDetectorRef,
    private loadService: LoadService, private fb: FormBuilder) {
  }

  ngOnInit() {
    this.formData = this.fb.group({
      projectCtr: ['', [Validators.required]],
      emailCtr: ['', [
        Validators.required,
        Validators.email
      ]],
      roleCtr: [''],
      ntIDCtr: ['']
    });
    this.reset();
    this.loadData();
    if (this.data !== null) {
      this.user.ntId = this.data.username;
      this.user.email = this.data.email;
      this.user.useSSO = this.data.useSSO;
      this.user.userRId = this.data.userRId;
      this.user.sites = this.data.sites;
      this.user.sites.forEach(site => this.selectedSiteIds.push(site.siteId));
      this.tittle = 'Edit User';
      this.add_eidt_label = 'Edit User'
      this.isEditMode = true;
    } else {
      this.isSelected = true;
      this.tittle = 'Add New User';
      this.add_eidt_label = 'Add User'
    }
  }
  close(confirm: boolean) {
    this.dialogRef.close({ status: confirm, data: this.user });
  }
  loadData() {
    const t = this;

    t.userManagementService.getSitesWithUsers().subscribe(data => {
      if (data && data.data.length > 0) {
        t.sites = data.data;
      }
    });
    t.userManagementService.getMaxSiteUserPerSite().subscribe(data => {
      if (data) {
        t.maxSiteUserPerSite = data.data;
      }
    });

    t.userManagementService.getSelectableRoles().subscribe(data => {
      if (data && data.data.length > 0) {
        t.roles = data.data;
        if (!this.isNullOrUndefined(t.data)) {
          t.user.role = t.roles.find(c => c.roleRId === t.data.roleRId);
          t.roleChange(t.user.role);
        }

      }
    });
    if (!this.isNullOrUndefined(this.data)) {
      t.userManagementService.getActivitiesOfUser(this.data.username).subscribe(data => {
        if (data && data.data.length > 0) {
          this.user.activities = data.data;
          this.countSelected = data.data.length;
        }
      });
    }
  }
  reset() {
    this.user = {
      emailRecipientClass: 'To',
      email: '',
      userRId: '',
      ntId: '',
      role: {},
      sites: [],
      activities: [],
      useSSO: false
    };
    this.selectedSiteIds = [];
  }
  save() {
    const t = this;
    if (this.formData.valid && this.validateForm()) {
      if (this.isEditMode) {
        t.userManagementService.updateUser(t.user).subscribe(data => {
          if (data.code !== 200) {
            t.alertService.showError(data.message);
          } else {
            t.user = data.data;
            t.openModal();
          }
        });
      } else {
        t.userManagementService.addUser(t.user).subscribe(data => {
          if (data.code !== 200) {
            t.alertService.showError(data.message);
          } else {
            t.user = data.data;
            t.openModal();
          }
        });
      }

    }
  }

  openModal() {
    const t = this;
    const dialogRef = this.dialog.open(AddUserSuccessModalComponent, {
      width: '800px'
    });
    dialogRef.componentInstance.user = t.user;

    dialogRef.afterClosed().subscribe(result => {
      if (result.status === true) {
        this.close(true);
      }
    });
  }
  showSSOLoginModal() {
    const t = this;
    const dialogRef = this.dialog.open(SsoLoginModalComponent, {
      width: '600px'
    });
    dialogRef.componentInstance.ntID = this.user.ntId;

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        t.validation = result.data.data;
        t.errMsg = result.data.message;
        t.error.validation = result.data.data;
        t.error.message = result.data.message;
      }
    });
  }
  showFeaturePopup() {
    const t = this;
    const dialogRef = this.dialog.open(FeatureSelectionModalComponent, {
      width: '1000px'
    });
    dialogRef.componentInstance.user = t.user;

    dialogRef.afterClosed().subscribe(result => {
      if (result.status === true && result.data) {
        this.countSelected = result.data.countSelected;
        if (!this.commonService.isNullOrUndefined(result.data.selectedFeatures) && result.data.selectedFeatures.length > 0) {
          this.selectedFeatures = result.data.selectedFeatures;
          this.user.activities = result.data.selectedFeatures;
        }

      }
    });
  }
  validateForm() {
    let result = true;
    
    if (!this.commonService.isNullOrUndefined(this.user.sites) && this.user.sites.length > 0) {
      this.user.sites.forEach(site => {
        if (!this.commonService.isNullOrUndefined(site) && !this.commonService.isNullOrUndefined(site.siteUsers)
          && site.siteUsers.length >= this.maxSiteUserPerSite) {

          this.error.role = 'This site has exceeded ' + this.maxSiteUserPerSite + 'users, cannot add more.';
          result = false;
        }
      });
    }
    return result;
  }
  public isFieldHasError = (fieldName: string, errorCode: string): boolean => {
    return this.formData.get(fieldName).hasError(errorCode);
  }
  emailRecipientClassChange(type) {
    this.user.emailRecipientClass = type;
  }

  roleChange(role) {
    
    if (this.commonService.isNullOrUndefined(role) || this.commonService.isNullOrUndefined(role.siteSelectionType)) {
      return;
    }
    switch (role.siteSelectionType) {
      case 'MULTIPLE':
        this.MULTIPLE_SITE = true;
        this.SINGLE_SITE = false;
        
        break;
      case 'SINGLE':
        this.MULTIPLE_SITE = false;
        this.SINGLE_SITE = true;
        
        break;
      default:
        this.MULTIPLE_SITE = false;
        this.SINGLE_SITE = true;
        break;
    }
    this.AddFeatureValidation(role);
  }

  AddFeatureValidation(role) {
    switch (role.siteSelectionType) {
      case "MULTIPLE":
        this.allowShowAddFeatureButton = true;
        break;
      case "SINGLE":

        this.allowShowAddFeatureButton = true;
        break;
      default:
        this.allowShowAddFeatureButton = false;
        break;
    }
  }
  siteChange(event) {
    const role: any = this.user.role;
    if (this.SINGLE_SITE) {
      const siteId = event.value;
      const site = this.sites.find(c => c.siteId === siteId);
      this.user.sites.push(site);
    } else {
      const findSites = event.value;
      if (!this.commonService.isNullOrUndefined(findSites) && findSites.length > 0) {
        this.user.sites = this.sites.filter(c => findSites.includes(c.siteId));
      }

    }

  }
  changeUserType(evt) {
    if (evt.value === 'SSO') {
      this.user.useSSO = true;
    } else {
      this.user.useSSO = false;
      this.user.ntId = '';
    }
    this.validation = undefined;
    this.errMsg = '';
    this.error.validation = undefined;
    this.error.message = '';
    this.ID_label = this.user.useSSO ? 'SSO ID' : 'Application ID';
  }
  validate() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && !currentUser.useSSO) {
      this.showSSOLoginModal();
    } else {
      const param = {
        'ntUsername': '',
        'ntPassword': '',
        'ntIDToCheck': this.user.ntId,
        'rememberMe': 'false'
      };
      this.userManagementService.ValidateNTID(param).subscribe(data => {
        if (data) {
          this.validation = data.data;
        }
      });
    }
  }
  isNullOrUndefined(x) {
    if (x == null) {
      return true;
    }

    if (x === null) {
      return true;
    }

    if (typeof x === 'undefined') {
      return true;
    }
    return false;
  }
}
